// @flow

import * as React from 'react';

import { css } from '@emotion/core';

let outer = css`
  margin: -3vw 0;
  
  @media print {
    margin: 0;
    padding: 0;
  }
`;

let page = css`
  width: 100%;
  padding: 3vw 0;
  
  @media print {
    margin: 0;
    padding: 0;
    display: block;
  }
`;

let content = css`
  width: 100%;
  max-width: 75rem;
  margin: 0 auto;
  padding: 0 .9375rem;
`;

export default class InnerPage extends React.Component<any> {
  render() {
    return <div css={outer}>
      <div css={page} {...this.props}>
        <div css={content}>
          <div>
            { this.props.children }
          </div>
        </div>
      </div>
    </div>;
  }
}